/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LeavePayloadV1 } from '../models/LeavePayloadV1';
import type { ReimbursementReceiptBase64UploadRequest } from '../models/ReimbursementReceiptBase64UploadRequest';
import type { ScheduleChangeReplaceRequest } from '../models/ScheduleChangeReplaceRequest';
import type { SuccessResponse_LeavePreflightResponse_ } from '../models/SuccessResponse_LeavePreflightResponse_';
import type { SuccessResponse_ReimbursementReceiptUploadResponse_ } from '../models/SuccessResponse_ReimbursementReceiptUploadResponse_';
import type { SuccessResponse_StoreWorkRequestListResponse_ } from '../models/SuccessResponse_StoreWorkRequestListResponse_';
import type { SuccessResponse_WorkRequestApproveResponse_ } from '../models/SuccessResponse_WorkRequestApproveResponse_';
import type { SuccessResponse_WorkRequestCreateResponse_ } from '../models/SuccessResponse_WorkRequestCreateResponse_';
import type { SuccessResponse_WorkRequestDetailResponse_ } from '../models/SuccessResponse_WorkRequestDetailResponse_';
import type { SuccessResponse_WorkRequestLifecycleResponse_ } from '../models/SuccessResponse_WorkRequestLifecycleResponse_';
import type { SuccessResponse_WorkRequestListResponse_ } from '../models/SuccessResponse_WorkRequestListResponse_';
import type { SuccessResponse_WorkRequestRejectResponse_ } from '../models/SuccessResponse_WorkRequestRejectResponse_';
import type { WorkRequestApproveRequest } from '../models/WorkRequestApproveRequest';
import type { WorkRequestCreateRequest } from '../models/WorkRequestCreateRequest';
import type { WorkRequestRejectRequest } from '../models/WorkRequestRejectRequest';
import type { WorkRequestResubmitRequest } from '../models/WorkRequestResubmitRequest';
import type { WorkRequestWithdrawRequest } from '../models/WorkRequestWithdrawRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WorkRequestsService {
    /**
     * Submit Work Request Endpoint
     * POST /api/v1/work_requests — 员工提交补卡申请 (§0.5 #8, D6 yes).
     * @returns SuccessResponse_WorkRequestCreateResponse_ Successful Response
     * @throws ApiError
     */
    public static submitWorkRequestEndpointApiV1WorkRequestsPost({
        requestBody,
    }: {
        requestBody: WorkRequestCreateRequest,
    }): CancelablePromise<SuccessResponse_WorkRequestCreateResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/work_requests',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List My Work Requests Endpoint
     * GET /api/v1/work_requests/me — 员工我的申请历史 (only-read, D6 exempt §0.5).
     * @returns SuccessResponse_WorkRequestListResponse_ Successful Response
     * @throws ApiError
     */
    public static listMyWorkRequestsEndpointApiV1WorkRequestsMeGet({
        status,
        limit = 50,
        cursor,
    }: {
        status?: (string | null),
        limit?: number,
        cursor?: (string | null),
    }): CancelablePromise<SuccessResponse_WorkRequestListResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/work_requests/me',
            query: {
                'status': status,
                'limit': limit,
                'cursor': cursor,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Preflight Leave Request Endpoint
     * POST /api/v1/work_requests/leave/preflight — 请假额度和审批链预检.
     * @returns SuccessResponse_LeavePreflightResponse_ Successful Response
     * @throws ApiError
     */
    public static preflightLeaveRequestEndpointApiV1WorkRequestsLeavePreflightPost({
        requestBody,
    }: {
        requestBody: LeavePayloadV1,
    }): CancelablePromise<SuccessResponse_LeavePreflightResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/work_requests/leave/preflight',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Upload Reimbursement Receipt Base64 Endpoint
     * POST /work_requests/reimbursement/receipts/base64 — 上传报销票据照片.
     * @returns SuccessResponse_ReimbursementReceiptUploadResponse_ Successful Response
     * @throws ApiError
     */
    public static uploadReimbursementReceiptBase64EndpointApiV1WorkRequestsReimbursementReceiptsBase64Post({
        requestBody,
    }: {
        requestBody: ReimbursementReceiptBase64UploadRequest,
    }): CancelablePromise<SuccessResponse_ReimbursementReceiptUploadResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/work_requests/reimbursement/receipts/base64',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Store Work Requests Endpoint
     * GET /api/v1/stores/{store_id}/work_requests — 店长待审列表 (only-read, D6 exempt §0.5).
     * @returns SuccessResponse_StoreWorkRequestListResponse_ Successful Response
     * @throws ApiError
     */
    public static listStoreWorkRequestsEndpointApiV1StoresStoreIdWorkRequestsGet({
        storeId,
        status = 'pending',
        requestType,
        submittedFrom,
        submittedTo,
        limit = 50,
        cursor,
    }: {
        storeId: number,
        status?: string,
        requestType?: (string | null),
        /**
         * 提交日期段起 (YYYY-MM-DD, 含当日)。Admin 审批「处理记录」筛选 2026-07-11。 服务端过滤 —— 前端不要在已加载页上做客户端过滤: 那只筛了当前这一页, 翻页就穿帮。
         */
        submittedFrom?: (string | null),
        /**
         * 提交日期段止 (YYYY-MM-DD, **含当日**)。后端按业务时区展成 [起 00:00, 止+1天 00:00), 所以选到 7-11 就真能看见 7-11 当天的单。from > to → 422(不静默交换)。
         */
        submittedTo?: (string | null),
        limit?: number,
        cursor?: (string | null),
    }): CancelablePromise<SuccessResponse_StoreWorkRequestListResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/stores/{store_id}/work_requests',
            path: {
                'store_id': storeId,
            },
            query: {
                'status': status,
                'request_type': requestType,
                'submitted_from': submittedFrom,
                'submitted_to': submittedTo,
                'limit': limit,
                'cursor': cursor,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Reimbursement Receipt Content Endpoint
     * GET /work_requests/{id}/reimbursement/receipts/{idx}/content — 票据照片代发.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static reimbursementReceiptContentEndpointApiV1WorkRequestsRequestIdReimbursementReceiptsPhotoIndexContentGet({
        requestId,
        photoIndex,
    }: {
        requestId: number,
        photoIndex: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/work_requests/{request_id}/reimbursement/receipts/{photo_index}/content',
            path: {
                'request_id': requestId,
                'photo_index': photoIndex,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Work Request Detail Endpoint
     * GET /api/v1/work_requests/{request_id} — 申请/审批详情 (only-read, D6 exempt §0.5).
     * @returns SuccessResponse_WorkRequestDetailResponse_ Successful Response
     * @throws ApiError
     */
    public static getWorkRequestDetailEndpointApiV1WorkRequestsRequestIdGet({
        requestId,
    }: {
        requestId: number,
    }): CancelablePromise<SuccessResponse_WorkRequestDetailResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/work_requests/{request_id}',
            path: {
                'request_id': requestId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Approve Work Request Endpoint
     * PATCH /api/v1/work_requests/{request_id}/approve — 店长批准 (§0.5 #9, D6 yes).
     * @returns SuccessResponse_WorkRequestApproveResponse_ Successful Response
     * @throws ApiError
     */
    public static approveWorkRequestEndpointApiV1WorkRequestsRequestIdApprovePatch({
        requestId,
        requestBody,
    }: {
        requestId: number,
        requestBody: WorkRequestApproveRequest,
    }): CancelablePromise<SuccessResponse_WorkRequestApproveResponse_> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/work_requests/{request_id}/approve',
            path: {
                'request_id': requestId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Replace Schedule Change Request Endpoint
     * POST /work_requests/{id}/replace — 撤回零决策旧单并原子提交新单.
     * @returns SuccessResponse_WorkRequestCreateResponse_ Successful Response
     * @throws ApiError
     */
    public static replaceScheduleChangeRequestEndpointApiV1WorkRequestsRequestIdReplacePost({
        requestId,
        requestBody,
    }: {
        requestId: number,
        requestBody: ScheduleChangeReplaceRequest,
    }): CancelablePromise<SuccessResponse_WorkRequestCreateResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/work_requests/{request_id}/replace',
            path: {
                'request_id': requestId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Reject Work Request Endpoint
     * PATCH /api/v1/work_requests/{request_id}/reject — 店长驳回 (§0.5 #10, D6 yes).
     * @returns SuccessResponse_WorkRequestRejectResponse_ Successful Response
     * @throws ApiError
     */
    public static rejectWorkRequestEndpointApiV1WorkRequestsRequestIdRejectPatch({
        requestId,
        requestBody,
    }: {
        requestId: number,
        requestBody: WorkRequestRejectRequest,
    }): CancelablePromise<SuccessResponse_WorkRequestRejectResponse_> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/work_requests/{request_id}/reject',
            path: {
                'request_id': requestId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Withdraw Work Request Endpoint
     * PATCH /work_requests/{request_id}/withdraw — 发起人无人处理前撤回.
     * @returns SuccessResponse_WorkRequestLifecycleResponse_ Successful Response
     * @throws ApiError
     */
    public static withdrawWorkRequestEndpointApiV1WorkRequestsRequestIdWithdrawPatch({
        requestId,
        requestBody,
    }: {
        requestId: number,
        requestBody: WorkRequestWithdrawRequest,
    }): CancelablePromise<SuccessResponse_WorkRequestLifecycleResponse_> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/work_requests/{request_id}/withdraw',
            path: {
                'request_id': requestId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Resubmit Work Request Endpoint
     * PATCH /work_requests/{request_id}/resubmit — 退回后发起人修改并重新提交.
     * @returns SuccessResponse_WorkRequestLifecycleResponse_ Successful Response
     * @throws ApiError
     */
    public static resubmitWorkRequestEndpointApiV1WorkRequestsRequestIdResubmitPatch({
        requestId,
        requestBody,
    }: {
        requestId: number,
        requestBody: WorkRequestResubmitRequest,
    }): CancelablePromise<SuccessResponse_WorkRequestLifecycleResponse_> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/work_requests/{request_id}/resubmit',
            path: {
                'request_id': requestId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
